import {
  BackButton,
  BlockContainer,
  BuyersCertificateCreateForm,
  BuyersCertificateCreateProvider,
  Title,
} from '@components';
import { useAppSelector, useAuth } from '@hooks';
import { getSpecialPage } from '@store/app/app.slice';

type BuyersCertificateCreateBlockProps = {
  title?: string;
  textMessage?: string;
};

export const BuyersCertificateCreateBlock: React.FC<BuyersCertificateCreateBlockProps> = ({
  title,
  textMessage,
}: BuyersCertificateCreateBlockProps) => {
  const { isBeremaUser } = useAuth();
  const dealerBuyersCertificateListPage = useAppSelector(
    getSpecialPage('dealerBuyersCertificateListPage')
  );
  const beremaBuyersCertificateListPage = useAppSelector(
    getSpecialPage('beremaBuyersCertificateListPage')
  );
  const buyersCertificateListPage = isBeremaUser
    ? beremaBuyersCertificateListPage
    : dealerBuyersCertificateListPage;
  return (
    <BlockContainer>
      <div className='buyers-certificate-create-block'>
        <BackButton href={buyersCertificateListPage} />
        {title && (
          <Title variant='h2' sx={{ mb: 4 }}>
            {title}
          </Title>
        )}
        <BuyersCertificateCreateProvider>
          <BuyersCertificateCreateForm textMessage={textMessage} />
        </BuyersCertificateCreateProvider>
      </div>
    </BlockContainer>
  );
};
